// extracted by mini-css-extract-plugin
export var img = "header-logo-module--img--q12iJ";
export var root = "header-logo-module--root---s+Qe";